import Clarity from '@microsoft/clarity'

class ClarityService {
  private isInitialized = false
  private readonly projectId: string

  constructor () {
    this.projectId = import.meta.env.VITE_CLARITY_PROJECT_ID || ''
  }

  init (): void {
    if (this.isInitialized || !this.projectId) {
      return
    }

    try {
      Clarity.init(this.projectId)
      this.isInitialized = true
      console.log('Clarity initialized successfully')
    } catch (error) {
      console.error('Failed to initialize Clarity:', error)
    }
  }

  setConsent (analyticsConsent: boolean, adsConsent: boolean = false): void {
    if (!this.isInitialized) {
      return
    }

    try {
      Clarity.consentV2({
        ad_Storage: adsConsent ? 'granted' : 'denied',
        analytics_Storage: analyticsConsent ? 'granted' : 'denied'
      })
      console.log('Clarity consent updated:', { analyticsConsent, adsConsent })
    } catch (error) {
      console.error('Failed to set Clarity consent:', error)
    }
  }

  identify (customId: string, friendlyName?: string): void {
    if (!this.isInitialized) {
      return
    }

    try {
      Clarity.identify(customId, undefined, undefined, friendlyName)
    } catch (error) {
      console.error('Failed to identify user in Clarity:', error)
    }
  }

  event (eventName: string): void {
    if (!this.isInitialized) {
      return
    }

    try {
      Clarity.event(eventName)
    } catch (error) {
      console.error('Failed to track Clarity event:', error)
    }
  }

  setTag (key: string, value: string | string[]): void {
    if (!this.isInitialized) {
      return
    }

    try {
      Clarity.setTag(key, value)
    } catch (error) {
      console.error('Failed to set Clarity tag:', error)
    }
  }
}

export const clarityService = new ClarityService()
